import { render, staticRenderFns } from "./SentNotificationPopup.vue?vue&type=template&id=25fbbbf4&scoped=true&"
import script from "./SentNotificationPopup.vue?vue&type=script&lang=js&"
export * from "./SentNotificationPopup.vue?vue&type=script&lang=js&"
import style0 from "./SentNotificationPopup.vue?vue&type=style&index=0&id=25fbbbf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fbbbf4",
  null
  
)

export default component.exports